module.exports = __webpack_public_path__ + "static/media/nyt.11a3ce46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/nyt.svg
// module id = 70
// module chunks = 0